import { baseRoute } from "../../../constants/routes";

export const APPEARANCE_BACKGROUNDS_ROUTE =
    baseRoute + "/appearance-backgrounds";

export const GET_APPEARANCE_BACKGROUNDS = "GET_APPEARANCE_BACKGROUNDS";
export const GET_APPEARANCE_BACKGROUNDS_SUCCESS =
    "GET_APPEARANCE_BACKGROUNDS_SUCCESS";
export const UPLOAD_APPEARANCE_BACKGROUND = "UPLOAD_APPEARANCE_BACKGROUND";
export const UPLOAD_APPEARANCE_BACKGROUND_SUCCESS =
    "UPLOAD_APPEARANCE_BACKGROUND_SUCCESS";
export const UPLOAD_APPEARANCE_BACKGROUND_FAILURE =
    "UPLOAD_APPEARANCE_BACKGROUND_FAILURE";
export const DELETE_APPEARANCE_BACKGROUND = "DELETE_APPEARANCE_BACKGROUND";
export const DELETE_APPEARANCE_BACKGROUND_SUCCESS =
    "DELETE_APPEARANCE_BACKGROUND_SUCCESS";
